export default __webpack_public_path__ + "static/media/slider3.1916f580.jpeg";